import actions from "./actions";

const initialState = {
  items: [],
  total: 0,
  loading: false,
  detail: null,
  detailLoading: false,
  saving: false,
  error: null,
};

export default function facilityCredentialReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SEARCH_REQUEST:
      return { ...state, loading: true };
    case actions.SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.items,
        total: action.total,
      };
    case actions.SEARCH_ERROR:
      return { ...state, loading: false, error: action.error };

    case actions.DETAIL_REQUEST:
      return { ...state, detailLoading: true };
    case actions.DETAIL_SUCCESS:
      return { ...state, detailLoading: false, detail: action.detail };
    case actions.DETAIL_ERROR:
      return { ...state, detailLoading: false, detail: null };
    case actions.RESET_DETAIL:
      return { ...state, detail: null };

    case actions.CREATE_REQUEST:
    case actions.UPDATE_REQUEST:
    case actions.DELETE_REQUEST:
      return { ...state, saving: true };
    case actions.CREATE_SUCCESS:
    case actions.UPDATE_SUCCESS:
    case actions.DELETE_SUCCESS:
      return { ...state, saving: false };
    case actions.CREATE_ERROR:
    case actions.UPDATE_ERROR:
    case actions.DELETE_ERROR:
      return { ...state, saving: false, error: action.error };

    default:
      return state;
  }
}
